module.exports = __webpack_public_path__ + "img/clip.16f353b4.svg";